import { Button, Heading, Icon, Text, VStack } from '@chakra-ui/react';
import { ReactComponent as close } from 'assets/close.svg';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { ROUTES } from 'router/routes';

export const OrderSummaryExpiredView = () => (
  <VStack bg='green.G700' textAlign='center' justifyContent='center' gap='16px' p='40px 16px'>
    <Icon as={close} boxSize='80px' color='red.G500' />
    <div>
      <Heading
        as='h1'
        variant={{ base: 'headingMedium', sm: 'headingLarge' }}
        mb='4px'
        color='white'
      >
        <FormattedMessage
          id='orderSummary.urlStatus.expired.title'
          defaultMessage='Payment link expired'
        />
      </Heading>
      <Text textStyle='bodyLargeRegular' color='white'>
        <FormattedMessage
          id='orderSummary.urlStatus.expired.descriptionFirstLine'
          defaultMessage='This payment session is no longer valid. Start a new order from the event page if you still want tickets.'
        />
      </Text>
    </div>
    <Button
      variant='primaryMedium'
      bg='green.G0'
      borderColor='green.G0'
      _hover={{ bg: 'green.G200', borderColor: 'green.G200' }}
      textColor='dark.D900'
      as={Link}
      to={ROUTES.home}
    >
      <FormattedMessage id='orderSummary.error.button' defaultMessage='Back to homepage' />
    </Button>
  </VStack>
);
